export default __webpack_public_path__ + "static/media/classify-nitish.73397bc7.jpg";